import React, { useState } from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import Select from 'react-select';
import SelectLib from './SelectLib';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#a71e3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #a71e3b' : 'none',
        '&:hover': { borderColor: '#a71e3b' },
        fontFamily: "'PT Sans Narrow', Arial, sans-serif"
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#a71e3b' : state.isFocused ? '#f5f5f5' : 'white',
        color: state.isSelected ? 'white' : '#333',
        fontFamily: "'PT Sans Narrow', Arial, sans-serif",
        '&:hover': { backgroundColor: state.isSelected ? '#a71e3b' : '#f5f5f5' }
    }),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: "'PT Sans Narrow', Arial, sans-serif",
        color: '#999'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontFamily: "'PT Sans Narrow', Arial, sans-serif"
    }),
    menu: (provided) => ({
        ...provided,
        fontFamily: "'PT Sans Narrow', Arial, sans-serif"
    })
};

function SelectAllocationMode(props) {
    const [allocationMode] = useState([
        { value: "all", label: "Tutte" },
        { value: "even", label: "Postazioni pari" },
        { value: "odd", label: "Postazioni dispari" },
        { value: "choose", label: "Postazioni selezionate" },
    ]);

    const [selected, setSelected] = useState();

    const showLibSelection = () => {
        if (selected == null) return null;

        return (
            <SelectLib
                apiAuthResponse={props.apiAuthResponse}
                setStudents={props.setStudents}
                students={props.students}
                setPhysicalLabs={props.setPhysicalLabs}
                physicalLabs={props.physicalLabs}
                allocationMode={selected.value}
            />
        );
    };

    function onSelectChange(selectedOption) {
        if (selectedOption) {
            setSelected(selectedOption);
        }
    }

    return (
        <>
            <Typography
                variant="body2"
                sx={{
                    fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                    fontWeight: 600,
                    mb: 1
                }}
            >
                Allocazione postazioni esame
            </Typography>

            <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={10}>
                        <Box sx={{ width: '85%' }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                                    fontWeight: 600,
                                    mb: 1
                                }}
                            >
                                Selezionare la modalità di allocazione postazioni
                            </Typography>
                            <Select
                                value={selected}
                                options={allocationMode}
                                isSearchable={false}
                                placeholder="Modalità allocazione"
                                onChange={onSelectChange}
                                styles={customStyles}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        {showLibSelection()}
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}

export default SelectAllocationMode;
